module.exports = __webpack_public_path__ + "static/media/square.8105dced.svg";